import { IFilterField } from 'models/types';

export const womeApplicationFilterSchema: IFilterField[] = [
  {
    label: 'Name Contains',
    name: 'name',
    widget: 'text',
  },
];
